import React from "react";
import "./Upgrade.css";
import greentick from "../../assets/greentick.svg";
import benefitsvideo from "../../assets/benefits.mp4";
const Upgrade = () => {
  const features = [
    {
      title: "Instant Contact Sharing",
      description:
        "Share your number, socials, website, and more in just one tap with our smart NFC card for business.",
    },
    {
      title: "One Card for Every Connection",
      description: "No need to carry stacks of paper cards or reorder them every few months. Your NFC card for business works smarter and lasts longer.",
    },
    {
      title: "Premium Yet Affordable",
      description:
        "Get a stylish NFC card for business with a premium finish at a price that makes sense for every professional.",
    },
    // {
    //   title: "Multi-Platform App",
    //   description:
    //     "Build & share your own business website on iOS, Android, & MacBook.",
    // },
    // {
    //   title: "More Clients, More Business",
    //   description: "Expand your network and get new opportunities.",
    // },
  ];

  return (
    <div id="upgrade" className="bigwrapper">
      <section className="sectionwrapper">
        <div className="upgradebox">
          <div className="upgradeLeft">
            <h1 className="upgradetitle">
              Everything You Need in One Smart NFC Card <span
              style={{display: "block", fontSize: "32px",lineHeight: "32px"}}
              > Instant Sharing. Premium Design.  Smarter Networking. </span>
           
            </h1>
            <div className="upgradesubtitle">
              <p className="fup">
               
               No bulk orders, no wasted paper, and no outdated business cards sitting in your drawer. Just one NFC card for business that stays updated and ready to share anytime.
              </p>
            
            
            </div>
            <ul className="upgradepoints">
              {features.map((feature, index) => (
                <li key={index}>
                  <img src={greentick} alt="tick" className="greentick" />
                  <div className="point">
                    <p className="ptitle">{feature.title}</p>
                    <p className="pdescription">{feature.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="upgradeRight">
            <video
              src={benefitsvideo}
              autoPlay
              loop
              muted
              controls
              className="upgradevideo"
            />
          </div>
        </div>
      </section>
    </div>
  );
};
export default Upgrade;
